import React from 'react';
import ApprovalList from '../ApprovalList';
import IPublishRequestOverview from '@Shared.Angular/@types/core/contracts/queryModel/governance/publishRequestOverview';

interface Props {
  isMobile: boolean;
  filteredItems: IPublishRequestOverview[];
}

const AllApprovalList: React.FC<Props> = ({ isMobile, filteredItems }) => {
  return (
    <ApprovalList
      isMobile={isMobile}
      filteredItems={filteredItems}
      roleLabel="Requested By"
      displayField="creatorName"
      emptyStateData={{
        summaryText: 'No active publish approval requests',
        bodyText: 'There are no pending publish requests in your organisation'
      }}
    />
  );
};

export default AllApprovalList;
